import styled from "styled-components"

import { GREY_01 } from '../../theme/colors'

export const Wrapper = styled.main`
	overflow-x:hidden;
	position: relative;
`

export const Container = styled.div`
	overflow: hidden;
	background-color: ${GREY_01};
`